<template>
<div id="company">
  <section id="company-top">
    <div class="company-top-img">
      <img src="../assets/img/representative.png">
      <div class="title">
        <span>代表あいさつ</span>
      </div>
      <div class="self-introduction">
        <span>代表取締役社長 浅原 孝経</span>
      </div>
    </div>
  </section>
  <section id="representative-greetings">
    <div class="wrapper">
      <div class="title">
        <span>次の10年に向けて</span>
      </div>
      <div class="message">
        <img src="../assets/img/representative-s.png">
        <span>当社は、設立から現在に至るまで、金融機関様を中心としたシステムの開発に携わっております。</span>
        <span class="br"/>
        <span class="br">取引所とOTCに対応したオンラインブローカー向けのASP型プラットフォーム、株・先物オプションの国内初高性能SPA、複数のアルゴリズムオートカバーに対応したFXディーリングシステム等のスクラッチ開発において、アーキテクチャデザイン、プロジェクトマネージメント、構築〜運用保守までを担い、おかげさまで、お客様からご評価をいただいております。</span>
        <span class="br"/>
        <span class="br">今年は、当社設立10周年目の節目となり、今までを第1創業期(成長準備期間)、これから先の10年間を第2創業期(成長期間)と捉えて、事業を拡大する方針へと舵を切り出しました。</span>
        <span class="br"/>
        <span class="br">設立時から多くのお客様から開発のご依頼を賜っておりますが、当社のリソース不足からお断りをさせていただくケースも少なくないため、リソースの改善を図ります。</span>
        <span class="br"/>
        <span class="br">まずは、多数の案件や大規模な開発でも当社のみでも請けられるよう、メンバーの増員を開始いたしました。当社では、創業時から入社条件として、知人か、知人の知り合いのみとしておりましたが、方針転換を行い、求人サイトにて募集を開始しております。</span>
        <span class="br"/>
        <span class="br">実践的なナレッジベースのカリキュラムでメンバーの育成を図り、大規模精鋭チームを組織してお客様のニーズにお応えできるようにいたします。</span>
        <span class="br"/>
        <span class="br">また、設備も充足させるため、本社を鎌倉の一間から神田小川町のオフィスビルへと移転をいたしました。当社では、ES(従業員満足)の向上こそCS(顧客満足)の向上と捉え、アメニティ環境や福利厚生を拡充していっております。</span>
        <span class="br"/>
        <span class="br">次に、2019年度内に新サービスのローンチをいたします。初回の規模は小さい事が予想されますが、ローンチサイクルをイテレーティブ化させ、第2創業期内に社会へ貢献できるサービスを創出いたします。</span>
        <span class="br"/>
        <span class="br">当社が創業から培ったナレッジやマインドと高い技術力で、必ずや事業の拡大を成功させ、お客様、お取引企業様、当社を選びついてきてくださるメンバーとそのご家族、そして、社会の皆々様へと貢献いたします。</span>
        <span class="br"/>
        <span class="br">何卒、皆々様のより一層のご指導、ご支援を賜りますよう、よろしくお願い申し上げます。</span>
        <span class="br"/>
      </div>
      <div class="sign">
        <div><span>代表取締役社長</span></div>
        <div><span>浅原 孝経</span></div>
      </div>
    </div>
  </section>
  <section id="company-prof-title">
    <div>
      <p>会社概要</p>
    </div>
  </section>
  <section id="company-prof">
    <div class="overview">
      <div class="overview-title">
        <span>会社名</span>
      </div>
      <div class="overview-content">
        <span>株式会社ビットハイブ</span>
        <span class="br">（英: Bithive Japan Inc.）</span>
      </div>
    </div>
    <div class="overview">
      <div class="overview-title">
        <span>資本金</span>
      </div>
      <div class="overview-content">
        <span>10,000,000円</span>
      </div>
    </div>
    <div class="overview">
      <div class="overview-title">
        <span>設立</span>
      </div>
      <div class="overview-content">
        <span>2009年4月6日</span>
      </div>
    </div>
    <div class="overview">
      <div class="overview-title">
        <span>本店所在地</span>
      </div>
      <div class="overview-content">
        <span>〒101-0052</span>
        <span class="br">東京都千代田区神田小川町1-9 川上ビル3F</span>
      </div>
      <div class="map-area">
        <div class="ggmap">
          <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3240.3021306965884!2d139.7639692152592!3d35.69418203019125!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x60184f85c5cc243f%3A0x1afa5799fe7acff5!2z5qCq5byP5Lya56S-44OT44OD44OI44OP44Kk44OW!5e0!3m2!1sja!2sjp!4v1555802735970!5m2!1sja!2sjp" width="600" height="450" frameborder="0" style="border:0" allowfullscreen></iframe>
        </div>
      </div>
    </div>
    <div class="overview">
      <div class="overview-title">
        <span>連絡先</span>
      </div>
      <div class="overview-content">
        <span>03-6811-7716 （代表電話）</span>
        <span class="br"><router-link :to="{ name: 'contact', params: {
            value: 'contact',
            from: 'company',
          }}">お問い合わせフォーム<font-awesome-icon icon="arrow-circle-right" /></router-link></span>
      </div>
    </div>
    <div class="overview">
      <div class="overview-title">
        <span>役員</span>
      </div>
      <div class="overview-content">
        <span>代表取締役 浅原 孝経</span>
      </div>
    </div>
    <div class="overview">
      <div class="overview-title">
        <span>社員数</span>
      </div>
      <div class="overview-content">
        <span>5名（2019年7月26日現在）</span>
      </div>
    </div>
    <div class="overview">
      <div class="overview-title">
        <span>事業内容</span>
      </div>
      <div class="overview-content">
        <ul>
          <li>証券（リテール）システム開発支援</li>
          <li>Web制作</li>
        </ul>
      </div>
    </div>
    <div class="overview">
      <div class="overview-title">
        <span>主要取引先銀行</span>
      </div>
      <div class="overview-content">
        <span>三菱UFJ銀行</span>
      </div>
    </div>
  </section>
</div>
</template>

<script>
export default {
  name: 'Company',
  mounted () {
    if (this.$route.params.value != null) {
      document.getElementById(this.$route.params.value).scrollIntoView()
      window.scrollBy(0, -58)
    }
  }
}
</script>

<style lang="scss">
@import "../assets/style/global.scss";

#company {
  > #company-top {
    > .company-top-img {
      position: relative;
      > img {
        @media screen and (max-width: 1024px) {
          display: block;
        }
        @media screen and (min-width: 1025px) {
          display: none;
        }
        width: 100%;
      }
      > .title {
        > span {
          letter-spacing:.5em;
          font-weight: 700;
        }
        @media screen and (max-width: 1024px) {
          position: absolute;
          top: 40%;
          left: 10%;
          > span {
            color: white;
            font-size: 5vw;
            text-shadow: 1px 1px 1px black;
          }
        }
        @media screen and (min-width: 1025px) {
          position: static;
          width: 100%;
          padding: 90px 0;
          > span {
            font-size: 48px;
          }
        }
      }
      > .self-introduction {
        @media screen and (max-width: 1024px) {
          display: block;
        }
        @media screen and (min-width: 1025px) {
          display: none;
        }
        position: absolute;
        bottom: 5%;
        right: 5%;
        > span {
          color: white;
          font-size: 3vw;
          letter-spacing: .2em;
          font-weight: 700;
          text-shadow: 1px 1px 1px black;
        }
      }
    }
  }
  #representative-greetings {
    > .wrapper {
      @media screen and (min-width: 1025px) {
        background-color: #f3f3f3;
        margin: 0 70px;
        padding: 80px 80px;
      }
      text-align: justify;
      text-justify: inter-ideograph;
      line-height: 30px;
      margin: 10px;
      > .title {
        border-left: solid 5px darkred;
        padding: 7px 0 7px 15px;
        font-weight: 700;
        background-color: #f3f3f3;
      }
      > .message {
        > img {
          @media screen and (max-width: 1024px) {
            display: none;
          }
          @media screen and (min-width: 1025px) {
            display: block;
          }
          float: right;
          width: 40%;
          margin: 0 0 0 80px;
        }
        padding: 30px 15px 15px 15px;
      }
      > .sign {
        padding: 0 15px 15px 0;
        text-align: right;
        font-weight: 700;
      }
    }
  }
  #company-prof-title {
    @media screen and (max-width: 1024px) {
      font-size: 5vw;
      padding: 20px 0;
    }
    @media screen and (min-width: 1025px) {
      font-size: 48px;
      padding: 90px 0;
    }
    font-weight: 700;
    letter-spacing:.5em;
  }
  #company-prof {
    @media screen and (max-width: 1024px) {
      margin: 10px 10px 60px 10px;
    }
    @media screen and (min-width: 1025px) {
      margin: 0 80px 80px 80px;
    }
    border-top: solid 1px #CCCCCC;
    border-left: solid 1px #CCCCCC;
    border-right: solid 1px #CCCCCC;
    text-align: left;
    color: #333;
    letter-spacing: .02em;
    > .overview {
      border-bottom: solid 1px #CCCCCC;
      > .overview-title {
        @media screen and (max-width: 1024px) {
          display: block;
          padding: 15px 13px 7px 13px;
        }
        @media screen and (min-width: 1025px) {
          display: inline-block;
          width: 230px;
          padding: 30px 0 30px 30px;
        }
        font-weight: 700;
      }
      > .overview-content {
        @media screen and (max-width: 1024px) {
          display: block;
        }
        @media screen and (min-width: 1025px) {
          display: inline-block;
          > span {
            display: inline-block;
          }
        }
        padding: 0 13px 17px 13px;
        > span {
          > a {
            text-decoration: none;
            color: cornflowerblue;
            &:hover {
              opacity: .6;
            }
            > svg {
              margin: 0 0 0 5px;
            }
          }
        }
        > ul {
          padding: 0 0 0 20px;
          > li {
            padding: 0 0 15px 0;
          }
        }
      }
      > .map-area {
        @media screen and (max-width: 1024px) {
          padding: 0 13px 17px 13px;
        }
        @media screen and (min-width: 1025px) {
          padding: 0 13px 17px 230px;
        }
        > .ggmap {
          position: relative;
          padding-bottom: 56.25%;
          padding-top: 30px;
          height: 0;
          overflow: hidden;
        }
        > .ggmap iframe,
        > .ggmap object,
        > .ggmap embed {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Company.vue